/**
 * 解析时间字符串
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * 处理模型文件 URL，解决 CORS 问题
 * 在开发环境使用代理，生产环境直接使用原始 URL
 * @param {string} url - 模型文件 URL
 * @returns {string} - 处理后的 URL
 */
export function getModelUrl(url) {
    if (!url) return url
    
    // 如果是相对路径或已经是代理路径，直接返回
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return url
    }
    
    // 检查是否是 models.qzctec.com 的 URL
    if (url.includes('models.qzctec.com')) {
        // 开发环境使用代理，生产环境直接使用
        if (process.env.NODE_ENV === 'development') {
            // 将 https://models.qzctec.com/xxx 转换为 /models-proxy/xxx
            return url.replace('https://models.qzctec.com', '/models-proxy')
        }
    }
    
    // 其他情况直接返回
    return url
}